
import { Component, Emit, Inject, Mixins, Prop, Watch } from 'vue-property-decorator';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import ItemActions from '../../../core/components/Actions/ItemActions.vue';
import SendItemDialog from './SendItemDialog.vue';
import Vue from 'vue'
import { ItemInfo } from '../../../shared/types/itemInfo';
import { FeatureCollection, MultiPolygon, PolyCoords } from 'shared/types/MapShapes';
import ModalCreatePolygonFromCoordinates from '../components/create_polygon_from_coordinates/ModalCreatePolygonFromCoordinates.vue';
import ModalListItems from '../components/list_items/ModalListItems.vue';
import AddPolygonsFromFile from './add_polygons_from_map/AddPolygonsFromFile.vue';
import { extractPolyCoords, normalizeToMultiPolygon } from '../../../core/utils/map-utils';
import { EventBus, TypeEventBus } from '../../../core/utils';
import { ItemPort } from '../../../core/api/ports';
import { InjectionKey } from '../../../core/injection-keys';
import { PolygonTool, TenantConfig } from '../../../tenants/types';
import { validationMessages } from '../../item/validationsMessages';
import { mergeFeatureCollections } from '../../../shared/helpers/geojson';
import AreaIndicator from './indicators/AreaIndicator.vue';
import CentroidIndicator from './indicators/CentroidIndicator.vue';
import PointSearch from '../../../core/components/Map/PointSearch.vue';
import { MapType } from '../../../core/components/Map/map-type';
import { LatLngPoint } from '../../../core/utils/point-coordinates';
@Component({
    components: {
        SimpleMap,
        SendItemDialog,
        ItemActions,
        ModalCreatePolygonFromCoordinates,
        AddPolygonsFromFile,
        ModalListItems,
        AreaIndicator,
        CentroidIndicator,
        PointSearch
    }
})
export default class ItemMap extends Vue {
  /** La vista de suscripción arranca en satélite en todos los clientes (no depende de `features.satelliteMapByDefault`). */
  mapType: MapType = MapType.Hybrid;
    @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
    @Inject(InjectionKey.ItemApi) readonly itemApi!: ItemPort;
    @Prop({default: null}) itemInfo: ItemInfo
    @Prop({default: 0}) diffPolygonsArea: number;
    @Prop({default: false}) isReadOnly: boolean;
    @Prop({default: '-'}) polygonsArea: string;
    @Prop({default: null}) centroidInfo: { lat: number, lng: number } | null;
    @Prop({ type: Boolean, default: false }) centroidIsValid!: boolean;
    disableHandDrawing: boolean = false;
    visibleModalListItems: boolean = false;
    disabledHandDrawing: boolean = false;
    visibleModalCreatePolygonFromCoordinates: boolean = false;
    visibleModalAddPolygonsFromFile: boolean = false;
    itemPolygon: MultiPolygon | null = null;
    polygonCoords: PolyCoords = [];
    cantSubmitReason: string = '';
    coordsEditCoordinates:google.maps.Data.Feature | null = null;
    polygonReallyModified: boolean = false;
    /** Panel "Buscar por punto (lat/lng)" abierto sobre el mapa. */
    visiblePointSearch: boolean = false;
    /** Ancho de la barra del centroide, para que el panel de "Buscar por punto" quede del mismo ancho. */
    pointSearchWidth: number | null = null;
    
    

    mounted(){
        this.setBasePolygon();
        EventBus.$on(TypeEventBus.HAND_WRITING_DISABLED_BUTTON, (value) => {
            this.disabledHandDrawing = value;
        })
        EventBus.$on(TypeEventBus.EDIT_COORDINATES, (coords: google.maps.Data.Feature) => {
            this.coordsEditCoordinates = coords;
            this.visibleModalCreatePolygonFromCoordinates = true;
            
        })

        EventBus.$on(TypeEventBus.SHOW_MESSAGE, (message: string, type: string) => {
            this.showSnackbar(message, type);
        })

    }

    //Seteo el poligono base que viene en el get del item
    setBasePolygon(){
        if(this.itemInfo && this.itemInfo.polygon){
            this.itemPolygon = this.itemInfo.polygon;
            let coords = extractPolyCoords(this.itemInfo.polygon)
            this.updatePolygonCoords(this.itemInfo.polygon);
            this.refreshAreaIndicator(coords);

        }
    }

    //Obtengo la referencia del SimpleMap para llamar sus metodos
    get mapItemElement(): HTMLFormElement {
        return this.$refs.itemMap as HTMLFormElement;
    }

    get sendItemDialogReference(): HTMLFormElement {
        return this.$refs.sendItemDialogRef as HTMLFormElement;
    }

    //Cuando se presiona el boton de "Dibujar Poligono"
   drawPolygon(){
    if(this.mapItemElement){
        this.mapItemElement.addNewPolygon();
    }
   }

   getPolygonFromMap(){
        return this.mapItemElement.getCoordsFromDataLayer();
   }

    //Este metodo se ejecuta luego de guardar el poligono en el Mapa
    //Se encarga de actualizar las coordenadas en SendItemDialog
   onPolygonSave(polyCoords: PolyCoords){
    this.updatePolygonCoordsInSendItemDialog(polyCoords);
    this.refreshAreaIndicator(polyCoords);
   }

   onGeometryPolygonModified(coords, reallyModified = false){
    this.polygonReallyModified = reallyModified;
    this.refreshAreaIndicator(coords);
   }

  

   async setNewPolygonInMap(geojson: FeatureCollection, overwrite: boolean = false){
    let resultGeojson = geojson;

    const mergeLoadedPolygons = !!(this.tenant.pages.item && this.tenant.pages.item.mergeLoadedPolygons);
    if (mergeLoadedPolygons && !overwrite && this.mapItemElement) {
      const currentGeojson = await this.mapItemElement.getCurrentFeatureCollection();
      resultGeojson = mergeFeatureCollections(currentGeojson, geojson);
    }

    this.itemPolygon = resultGeojson;
    this.mapItemElement.addGeoJson(resultGeojson);
    this.updatePolygonCoords(resultGeojson);
    this.refreshAreaIndicator(extractPolyCoords(resultGeojson));
    this.showSnackbar('Poligono actualizado', 'success');
   }

   updatePolygonCoords(geojson: FeatureCollection){
    let newCoordinates: PolyCoords = extractPolyCoords(geojson);
    this.updatePolygonCoordsInSendItemDialog(newCoordinates);
   }

   refreshAreaIndicator(newCoordinates){
       EventBus.$emit(TypeEventBus.CALCULATING_POLYGON_AREA, true);
       this.itemApi.getPolygonArea(
        {
            polygon: newCoordinates,
        }
     ).then(response => {
         this.updateAreaIndicator(response);
     }).finally(() => {
         EventBus.$emit(TypeEventBus.CALCULATING_POLYGON_AREA, false);
     })
   }

   @Emit() 
   leaveItem(newUrl: string){}

   get polygonHasCoordinates(){
       return this.polygonCoords.length > 0
   }

   get getSubmitTooltip(){
    if(!this.polygonHasCoordinates){
        return validationMessages.NO_POLYGON_TO_SAVE
    }

    if(this.disabledHandDrawing){
        return validationMessages.POINT_WITHOUT_SAVE
    }

    if(this.diffPolygonsArea > 20){
        return validationMessages.DIFF_AREA_BIG;
    }
   }

   get polygonTools(): PolygonTool[] {
    return this.tenant.pages.item ? this.tenant.pages.item.polygonTools : [];
   }

   get coordinatesToolEnabled(): boolean {
    return this.polygonTools.includes(PolygonTool.Coordinates);
   }

   get pointSearchEnabled(): boolean {
    return this.polygonTools.includes(PolygonTool.PointSearch);
   }

   onPointSearch(point: LatLngPoint){
    if(this.mapItemElement){
        this.mapItemElement.showSearchPoint(point);
    }
   }

   clearSearchPoint(){
    if(this.mapItemElement){
        this.mapItemElement.clearSearchPoint();
    }
   }

   /** Abre el panel con el ancho de la barra del centroide (se mide al abrir: es un método, el centroide puede recrearse). */
   openPointSearch(){
    this.visiblePointSearch = true;
    this.$nextTick(() => {
      const centroid = this.$refs.centroidIndicator as Vue | undefined;
      const el = centroid ? (centroid.$el as HTMLElement) : null;
      this.pointSearchWidth = el ? el.getBoundingClientRect().width : null;
    });
   }

   closePointSearch(){
    this.visiblePointSearch = false;
    this.clearSearchPoint();
   }

   /**
    * Al abrirse "Modificar polígono" se oculta el panel (ocupan la misma esquina) pero el marcador queda, para dibujar
    * alrededor del punto. Se saca con Limpiar o la × al volver a abrir el panel.
    */
   onPolygonEditionVisibility(visible: boolean){
    if(visible){
        this.visiblePointSearch = false;
    }
   }

   closeModalFromCoordinates(){
    this.visibleModalCreatePolygonFromCoordinates = false;
    this.coordsEditCoordinates = null;
   }

 

   updatePolygonCoordsInSendItemDialog(coordinates){
       this.polygonCoords = coordinates;
   }


    
   @Emit()
   updateAreaIndicator(response){}

   @Emit()
   showSnackbar(message: string, type: string){
       
   }
}
